module.exports = "https://cdn2-fs.clearscore.com/flux/images/615f831891c5086cafd844adbdbe2be5.jpg";